<template>
  <div class="product_img_scroll">
    <!-- <fixed-header> -->
    <BrandHeader></BrandHeader>
    <Breadcrumb></Breadcrumb>
    <!-- Removed delivery area from here -->
    <!-- <brand-filter /> -->
    <navigation></navigation>
    <!-- </fixed-header> -->
    <div class="menulist" :class="{ 'menu-scroll-padding': fixTop }">
      <div
        class="no-item-found custom-padding section-t-space"
        v-if="all_store_categories.length < 1 || !itemsFound"
      >
        <div style="padding-top: 60px"></div>
        <h2>{{ _T('No Item found') }}</h2>
        <div v-if="searchItem">
          <button class="btn btn-solid" @click="clearSearch">
            {{ _T('Clear Search') }}
          </button>
        </div>
      </div>
      <div class="menu-list-items" v-else>
        <div
          v-for="category in all_store_categories"
          :key="category._id"
          class="custom-padding fixed-mp-cls"
          :id="seoName(category.name)"
        >
          <div
            class="title pb-3 cat-title"
            ref="category_title"
            :id="'product_listing_title_' + category._id"
            v-if="products(category._id).length"
          >
            <h3 :id="seoName(category.name)">{{ _T_DB(category, 'name') }}</h3>
            <hr />
          </div>
          <div
            class="row custom_col ratio_94 category-entry"
            :id="'product_listing_box_' + category._id"
            :class="currentBrand ? currentBrand.item_layout : null"
          >
            <template v-for="menu in products(category._id)">
              <keep-alive-global :key="'alive_menu_tile_' + menu._id">
                <component
                  :is="'MenuTile'"
                  :name="'menutTile_' + menu._id"
                  :key="'menutTile_' + menu._id"
                  :item="menu"
                  :id="menu._id"
                />
              </keep-alive-global>
            </template>
          </div>
        </div>
      </div>
      <comboBox />
      <Modifier :item="selectedItem" />
    </div>
  </div>
</template>
<script>
import KeepAliveGlobal from 'vue-keep-alive-global'
import { mapGetters, mapState } from 'vuex'
import BrandHeader from './Menu/Brand_Header'
import Breadcrumb from './Menu/Breadcrumb'
import MenuTile from '../Collections/MenuTile'
import ComboBox from '@/components/Blocks/Combo/comboBox'
import Navigation from './Menu/Navigation'
//import CartMixin from '@/mixins/CartMixin.js'
import Modifier from '@/components/Blocks/Cart/MobileCart/Modifier'
//import BrandFilter from '@/components/Blocks/Filter/BrandFilter'

import { seo_name } from '@/utils/main_utils'
import { eventBus } from '@/eventBus'

export default {
  name: 'MenuList',
  components: {
    BrandHeader,
    KeepAliveGlobal,
    Breadcrumb,
    MenuTile,
    Navigation,
    ComboBox,
    //BrandFilter,
    Modifier,
  },
  data() {
    return {
      renderKey: 0,
      fixTop: false,
      scrollMargin: 0,
      catId: 0,
      mleft: 0,
      scrollPos: 0,
      is_country_change: false,
    }
  },
  watch: {
    selectedDa() {
      this.renderKey += 1
    },
    selectedCountry() {
      this.is_country_change = false
    },
    selectedOffer(val) {
      let offer = val
      if (offer.offer_type === this.CONST.OFFER_TYPE_ITEM) {
        let menuItems = this.menu_items
        if (menuItems) {
          let menuItem = menuItems.find(
            menuItem => menuItem.name === offer.offer_value
          )
          if (menuItem) {
            this.addToCart(menuItem)
          }
        }
      } else if (offer.offer_type === this.CONST.OFFER_TYPE_CATEGORY) {
        this.$store.dispatch('resolveCategory', offer.offer_value).then(() => {
          if (this.selected_category) {
            this.$router.push({
              name: this.brandStoreRoute('store_page_category'),
              params: { category_name: seo_name(this.selected_category.name) },
            })
          }
        })
      }
    },
  },
  created() {
    window.addEventListener('scroll', this.handleScroll)
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    clearSearch() {
      eventBus.$emit('clear-search')
    },
    // eslint-disable-next-line no-unused-vars
    handleScroll(event) {
      // if (window.scrollY > 300) this.fixTop = true
      // else
      this.fixTop = false
    },
    // itemsCollection(categoryId) {
    //   return {
    //     'Most Popular': this.regularItems(categoryId),
    //     'Combo Meals': this.comboItems(categoryId),
    //   }
    // },
    // comboItems(categoryId) {
    //   return this.category_products(categoryId).filter(
    //     item => item.item_type === 'combo_item'
    //   )
    // },
    // regularItems(categoryId) {
    //   return this.category_products(categoryId).filter(
    //     item => item.item_type !== 'combo_item'
    //   )
    // },
    seoName(name) {
      return seo_name(name)
    },
  },
  computed: {
    ...mapGetters([
      'all_store_categories',
      'category_products',
      '_T',
      '_T_DB',
      'menu_items',
      'selectedOffer',
      'searchItem',
      'currentBrand',
      'selectedCountry',
      'item_price_set_currency',
      'brandStoreRoute',
      'selected_category',
      'selectedDa',
    ]),
    ...mapState({
      selectedItem: state => state.cart_store.selectedItem,
    }),
    itemsFound() {
      let found = false
      this.all_store_categories.forEach(category => {
        const products = this.products(category._id)
        Object.freeze(products)
        if (products && products.length) {
          found = true
        }
      })
      return found
    },
    products() {
      return Object.freeze(this.category_products)
    },
  },
  beforeMount() {
    let offer = this.selectedOffer
    if (offer.offer_type === this.CONST.OFFER_TYPE_ITEM) {
      let menuItems = this.menu_items
      if (menuItems) {
        let menuItem = menuItems.find(
          menuItem => menuItem.name === offer.offer_value
        )
        if (menuItem) {
          this.addToCart(menuItem)
        }
      }
    } else if (offer.offer_type === this.CONST.OFFER_TYPE_CATEGORY) {
      this.$store.dispatch('resolveCategory', offer.offer_value).then(() => {
        if (this.selected_category) {
          this.$router.push({
            name: this.brandStoreRoute('store_page_category'),
            params: { category_name: seo_name(this.selected_category.name) },
          })
        }
      })
    }
  },
  beforeDestroy() {
    eventBus.$off('clear-search')
  },
}
</script>

<style lang="scss" scoped>
.body-rtl {
  .title {
    h3 {
      text-align: right;
    }
  }
}
.menulist {
  .fixed-mp-cls {
    &:last-child {
      margin-bottom: $px60;
    }
  }
}
.menu-scroll-padding {
  padding-top: $px85;
}
.cat-title {
  h3 {
    color: $color-primary;
  }
}
@media (max-width: 767px) {
  .menu-scroll-padding {
    padding: 0;
  }
  .fixed-mp-cls {
    margin-bottom: 0;
  }
}
@media (max-width: 575px) {
  .custom-padding {
    padding-left: $px15;
    padding-right: $px15;
  }
}
.debug {
  position: fixed;
  right: 0;
  background-color: #fff;
  margin-right: 2rem;
  border: 1px solid red;
  margin-top: 2rem;
  padding: 0.5rem;
}
</style>
